export const getTripFromCarryingCargoByStep = (carryingCargo, step) => carryingCargo.list
    .find(aTrip => aTrip.stopList
        .find(aStop => aStop.stepId === step.stepId) ? true : false 
    );